
import React, { Component } from "react";
import {Box, HStack, Text} from "@chakra-ui/react";
import MultiToggle from "react-multi-toggle";
import "./css/MultiToggleStyles.css";

import TextEditInput from "./TextEditInput";




export default class CheckListCardInput2 extends Component 
{
    constructor(props)
    {
        super(props);

        this.state = {
            toggleValue: " ",
            commentValue: ""
        }

        this.onChange = this.onChange.bind(this);
        this.onCommentChange = this.onCommentChange.bind(this);
    }

    componentDidUpdate(prevProps)
    {
        if (this.props.cardValue !== prevProps.cardValue)
        {
            this.setState({toggleValue: this.props.cardValue});
        }
    }

    onChange(value)
    {
        
        this.setState({toggleValue: value});
        this.props.onValueChange(value, this.props.card.id);
    }

    onCommentChange(value)
    {
        this.setState({commentValue: value});
        this.props.onValueChange(value, this.props.card.id + "-comment");
    }







    render() 
    {
        var multiToggleOptions = (this.props.card.toggleOptions) ? this.props.card.toggleOptions.map((opt) => {return {displayName: opt.label, value: opt.value};}) :
            [{displayName: "PASS", value: "pass"}, {displayName: "", value: " "}];
        var commentCardId = this.props.card.id + "-comments";
        var commentCard ={
            id :commentCardId,
            title: "Fail Comments",
            fieldType: "texteditor"
        };
        var bkgColor = (this.state.toggleValue === "pass") ? "lightgreen" :
            (this.state.toggleValue === "fail") ? "red" : "";
        

        return (
                <div style={{backgroundColor: bkgColor}}>
                <MultiToggle
                    options={multiToggleOptions}
                    selectedOption={this.state.toggleValue}
                    onSelectOption={(value) => this.onChange(value)}
                    label={(this.props.card.caption) ? this.props.card.caption : ""}
                />
                
                {(this.state.toggleValue === "fail") &&
                <TextEditInput 
                    card={commentCard} 
                    cardValue={this.state.commentValue} 
                    onValueChange={this.onCommentChange} 
                    gcid={this.props.gcid} 
                    token={this.props.token} 
                    onlineInfo={this.props.onlineInfo}
                />
                }
 

                </div>

          );
    }
}







